<template>
    <div class="employees-availability-content-wrap availability card-box-style rounded rounded-30">
        <div class="employees-availability-content">
            <div class="main-title d-flex justify-content-between align-items-center">
                <h3>Employees Availability</h3>

                <select class="form-select form-control" aria-label="Default select example">
                    <option selected>30 days</option>
                    <option value="1">15 days</option>
                    <option value="2">10 days</option>
                    <option value="3">5 days</option>
                </select>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-12 col-sm-6 col-md-4">
                    <div class="single-employees-availability d-flex justify-content-between align-items-center">
                        <div class="employees-availability-content">
                            <h5>Attendance</h5>
                            <h4>24.67% <span>+04.18%</span></h4>
                        </div>
                        <div class="employees-chart">
                            <div id="chart">
                                <apexchart type="area" height="50" :options="attendanceChart" :series="attendance"></apexchart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-6 col-md-4">
                    <div class="single-employees-availability d-flex justify-content-between align-items-center">
                        <div class="employees-availability-content color-style-fe5957">
                            <h5>Late Coming</h5>
                            <h4>7.32% <span>-0.21%</span></h4>
                        </div>
                        <div class="employees-chart">
                            <div id="chart">
                                <apexchart type="area" height="50" :options="lateComing" :series="late"></apexchart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-6 col-md-4">
                    <div class="single-employees-availability d-flex justify-content-between align-items-center">
                        <div class="employees-availability-content">
                            <h5>Absent</h5>
                            <h4>34 <span>+2.50%</span></h4>
                        </div>
                        <div class="employees-chart">
                            <div id="chart">
                                <apexchart type="area" height="50" :options="absentChart" :series="absent"></apexchart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmployeesAvailability',
    data: function() {
        return {
            attendance: [{
                name: 'Attendance',
                    data: [0, 50, 100, 50, 42, 150, 47, 75, 10, 100, 14]
                },
            ],
            attendanceChart: {
                chart: { 
                    type: "area", 
                    height: 50, 
                    sparkline: { 
                        enabled: !0 
                    } 
                },
                stroke: { 
                    curve: "smooth", 
                    width: 4,
                    lineCap: "round" 
                },
                colors: [
                    "#5C31D6"
                ],
                fill: { 
                    type: "gradient", 
                    gradient: { 
                        shadeIntensity: 0, 
                        inverseColors: !0, 
                        opacityFrom: 0, 
                        opacityTo: 0, 
                        stops: [
                            75, 100, 100, 100
                        ] 
                    } 
                },
                tooltip: { 
                    fixed: { 
                        enabled: !1 
                    }, 
                    x: { 
                        show: !1 
                    }, 
                    marker: { 
                        show: !1 
                    } 
                },
            },
            late: [{
                name: 'Late Coming',
                    data: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14]
                },
            ],
            lateComing: {
                chart: { 
                    type: "area", 
                    height: 50, 
                    sparkline: { 
                        enabled: !0 
                    } 
                },
                stroke: { 
                    curve: "smooth", 
                    width: 4,
                    lineCap: "round" 
                },
                colors: [
                    "#4FCB8D"
                ],
                fill: { 
                    type: "gradient", 
                    gradient: { 
                        shadeIntensity: 0, 
                        inverseColors: !0, 
                        opacityFrom: 0, 
                        opacityTo: 0, 
                        stops: [
                            75, 100, 100, 100
                        ] 
                    } 
                },
                tooltip: { 
                    fixed: { 
                        enabled: !1 
                    }, 
                    x: { 
                        show: !1 
                    }, 
                    marker: { 
                        show: !1 
                    } 
                },
            },
            absent: [{ 
                name: "Absent", 
                data: [0, 50, 70, 5, 42, 15, 47, 75, 65, 19, 14] 
            }],
            absentChart: {
                chart: { 
                    type: "area", 
                    height: 50, 
                    sparkline: { 
                        enabled: !0 
                    } 
                },
                stroke: { 
                    curve: "smooth", 
                    width: 4,
                    lineCap: "round" 
                },
                colors: [
                    "#1765FD"
                ],
                fill: { 
                    type: "gradient", 
                    gradient: { 
                        shadeIntensity: 0, 
                        inverseColors: !0, 
                        opacityFrom: 0, 
                        opacityTo: 0, 
                        stops: [
                            75, 100, 100, 100
                        ] 
                    } 
                },
                tooltip: { 
                    fixed: { 
                        enabled: !1 
                    }, 
                    x: { 
                        show: !1 
                    }, 
                    marker: { 
                        show: !1 
                    } 
                },
            },
        }
    },
}
</script>

<style lang="scss">
.single-employees {
	padding-left: 10px;
	margin-bottom: 20px;
	position: relative;
	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 100%;
		background-color: #1765fd;
		border-radius: 30px;
	}
	.title {
		font-size: 13px;
		font-weight: 500;
		letter-spacing: -0.26px;
		display: block;
		margin-bottom: 4px;
	}
	h4 {
		font-size: 14px;
		span {
			font-size: 11px;
			color: #BCC2CF;
			font-weight: 500;
		}
	}
	&.border-style-5c31d6 {
		&::before {
			background-color: #5c31d6;
		}
	}
	&.border-style-4fcb8d {
		&::before {
			background-color: #4fcb8d;
		}
	}
	&.border-style-1765fd {
		&::before {
			background-color: #1765fd;
		}
	}
}
.employees-availability-content-wrap {
	padding-top: 22px !important;
	padding-bottom: 2px !important;
	.main-title {
		margin-bottom: 38px;
	}
	&.availability {
		padding-bottom: 10px !important;
	}
}
.single-employees-availability {
	background: #FFFFFF 0% 0% no-repeat padding-box;
	box-shadow: 0px 5px 25px #CAD6F266;
	border: 1px solid #DFE9FF;
	border-radius: 20px;
	padding: 28px 30px;
	transition: var(--transition);
	margin-bottom: 20px;
	.employees-availability-content {
		h5 {
			font-weight: 500;
			font-size: 14px;
			color: var(--body-color);
			margin-bottom: 10px;
		}
		h4 {
			letter-spacing: -0.32px;
			font-size: 16px;
			margin-bottom: 0;
			span {
				font-size: 12px;
				color: #28C76F;
				font-weight: 500;
			}
		}
		&.color-style-fe5957 {
			h4 {
				span {
					color: #fe5957;
				}
			}
		}
	}
	.employees-chart {
		max-width: 200px;
	}
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
    .employees-availability-content-wrap {
        .main-title {
            margin-bottom: 30px;
        }
        &.availability {
            padding-bottom: 0;
        }
    }
    .single-employees-availability {
        padding: 15px;
        display: block !important;
        .employees-chart {
            max-width: 100%;
        }
    }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
    .single-employees-availability {
        padding: 20px;
        display: block !important;
        margin-bottom: 0;
        .employees-chart {
            margin-top: 10px;
        }
    }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
	.employees-availability-content-wrap {
        &.availability {
            padding-bottom: 0;
            .col-lg-12 {
                flex: 0 0 auto;
                max-width: 50%;
            }
        }
    }
    .single-employees-availability {
        padding: 20px;
        .employees-chart {
            max-width: 120px;
        }
    }
    .card-box-style {
        padding: 20px;
        &.rounded-30 {
            padding: 20px;
        }
    }
}
</style>